import { createRoot } from 'react-dom/client';
import { JobListingMain } from './components';

document.querySelectorAll('[data-aq-jobs-render="listing-main"]').forEach((element) => {
  const root = createRoot(element);
  root.render(<JobListingMain />);
});
